/**
 * Map từ RefType sang tên form chi tiết
 * Mục đích tạo file này là do 1 file Detail có thể chứa 2 reftype RefTypeMapperDetailName
 * NXCHIEN 19.05.2022
 */
export default {
  // Phiếu chi
  CashPaymentDetail: 21,
  // Phiếu thu
  CashReceiptDetail: 20,
  // Chuyển kho nội bộ
  AssetTransferDetail: 62,
  // Chuyển kho nội bộ
  AssetTransferDetail: 62,
  //Phiếu nhập kho
  InwardStockDetail: 60,
  //Phiếu xuất kho
  OutwardStockDetail: 61,
  //Phiếu kết chuyển
  AccountTransferSlipVoucherDetail: 70,
  JusticeReceiptDetail: 71,
  DistributionSellingAssetDetail: 72,
  //Phiếu xác định tiền, giá trị TSTV
  AssetEvaluationDetail: 98,
  // Kiểm kê tài sản, tang vật
  InventoryDetail: 120,

  // Chứng từ nghiệp vụ khác
  GeneralJournalEntryDetail: 80,
  // Séc
  ChequeDetail: 40,
  // Phiếu nộp tiền vào tài khoản
  DepositDetail: 41,
  // Phiếu xác định tiền, giá trị TSTV
  AssetEvaluationDetail: 98,
  // Bảng tổng hợp chứng từ cùng loại
  VoucherListDetail: 99,
  // Số dư ban đầu
  InitialBalanceDetailPopup: [90, 91, 92, 93, 94],
  // Chuyển chấp hành viên theo quyết định
  TransferExecutorDetail: 121
};
